<ng-container *ngIf="isOpenSideBar; else openSideBarDefault">
  <div class="w-100">
    <app-sidebar-group />
  </div>
</ng-container>
<ng-template #openSideBarDefault>
  <app-navbar></app-navbar>
  <div class="d-flex" style="min-height: calc(100vh - 66px)">
    <app-sidebar></app-sidebar>
    <div
      class="flex-grow-1 p-4 layout-bg"
      [style.width.px]="breakpointMdScreen"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</ng-template>
